import { lazy } from "react";
import { Navigate } from "react-router-dom";

// project import
import Loadable from '@/components/Loadable';
import MinimalLayout from '@/layout/MinimalLayout';

// render - login
const AuthLogin = Loadable(lazy(() => import("@/pages/authentication/Login")));
const PageNotFound = Loadable(
  lazy(() => import("@/components/PageNotFound"))
);
// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = () => {
  return {
    path: "/",
    element: <MinimalLayout />,
    children: [
      {
        path: "/",
        element: <Navigate to="/login" replace />,
      },
      {
        path: "/not-found",
        element: <PageNotFound />,
      },
      {
        path: "/login",
        element: <AuthLogin />,
      },
    ],
  };
};

export default LoginRoutes;
